var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main-content" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "card" },
      [
        _c("div", { staticClass: "card-header" }, [
          _c(
            "div",
            { staticClass: "btn-group", attrs: { role: "group" } },
            [
              _c(
                "v-dropdown",
                { attrs: { id: "ddown2", right: "" } },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-default dropdown-toggle",
                      attrs: {
                        slot: "activator",
                        id: "btnGroupDrop1",
                        type: "button",
                        "data-toggle": "dropdown",
                        "aria-haspopup": "true",
                        "aria-expanded": "false"
                      },
                      slot: "activator"
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.columna.text) +
                          "\n          "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.options, function(dato, index) {
                    return _c("v-dropdown-item", { key: index }, [
                      _c(
                        "a",
                        {
                          staticClass: "dropdown-item",
                          on: {
                            click: function($event) {
                              return _vm.changeTypeSearch(dato)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(dato.text) +
                              "\n            "
                          )
                        ]
                      )
                    ])
                  })
                ],
                2
              )
            ],
            1
          ),
          _c("br")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "card-body" }, [
          _vm.columna.value == "personal"
            ? _c("h4", [_vm._v("Reportes de personal")])
            : _vm._e(),
          _vm._v(" "),
          _vm.columna.value == "compras"
            ? _c("h4", [_vm._v("Reportes de compras")])
            : _vm._e(),
          _vm._v(" "),
          _vm.columna.value == "ventas"
            ? _c("h4", [_vm._v("Reportes de ventas")])
            : _vm._e(),
          _vm._v(" "),
          _vm.columna.value == "personal"
            ? _c("table", { staticClass: "table table-responsive" }, [
                _vm._m(1),
                _vm._v(" "),
                _c("tbody", [
                  _c("tr", [
                    _c("td", [
                      _c(
                        "button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip.top-center",
                              value: "Generar reporte",
                              expression: "'Generar reporte'",
                              modifiers: { "top-center": true }
                            }
                          ],
                          staticClass: "btn btn-primary btn-sm",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.openModal("personal", "especifico1")
                            }
                          }
                        },
                        [_c("i", { staticClass: "icon-fa icon-fa-file-text" })]
                      ),
                      _vm._v("  \n            ")
                    ]),
                    _vm._v(" "),
                    _c("td", [_vm._v("Reporte empleado que más vende")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("Presenta ")])
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", [
                      _c(
                        "button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip.top-center",
                              value: "Generar reporte",
                              expression: "'Generar reporte'",
                              modifiers: { "top-center": true }
                            }
                          ],
                          staticClass: "btn btn-primary btn-sm",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.openModal("personal", "especifico1")
                            }
                          }
                        },
                        [_c("i", { staticClass: "icon-fa icon-fa-file-text" })]
                      ),
                      _vm._v("  \n            ")
                    ]),
                    _vm._v(" "),
                    _c("td", [_vm._v("Reporte empleado que menos vende")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("Presenta ")])
                  ])
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.columna.value == "compras"
            ? _c("table", { staticClass: "table table-responsive" }, [
                _vm._m(2),
                _vm._v(" "),
                _c("tbody", [
                  _c("tr", [
                    _c("td", [
                      _c(
                        "button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip.top-center",
                              value: "Generar reporte",
                              expression: "'Generar reporte'",
                              modifiers: { "top-center": true }
                            }
                          ],
                          staticClass: "btn btn-primary btn-sm",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.openModal("compras", "mensual")
                            }
                          }
                        },
                        [_c("i", { staticClass: "icon-fa icon-fa-file-text" })]
                      ),
                      _vm._v("  \n            ")
                    ]),
                    _vm._v(" "),
                    _c("td", [_vm._v("Reporte de compras mensuales")]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v("Presenta el reporte de compras mensuales")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", [
                      _c(
                        "button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip.top-center",
                              value: "Generar reporte",
                              expression: "'Generar reporte'",
                              modifiers: { "top-center": true }
                            }
                          ],
                          staticClass: "btn btn-primary btn-sm",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.openModal("compras", "especifico")
                            }
                          }
                        },
                        [_c("i", { staticClass: "icon-fa icon-fa-file-text" })]
                      ),
                      _vm._v("  \n            ")
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        "Reporte de compras específicas, no mayor a 30 días"
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        "Presenta las compras dentro de un rango de fechas"
                      )
                    ])
                  ])
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.columna.value == "ventas"
            ? _c("table", { staticClass: "table table-responsive" }, [
                _vm._m(3),
                _vm._v(" "),
                _c("tbody", [
                  _c("tr", [
                    _c("td", [
                      _c(
                        "button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip.top-center",
                              value: "Generar reporte",
                              expression: "'Generar reporte'",
                              modifiers: { "top-center": true }
                            }
                          ],
                          staticClass: "btn btn-primary btn-sm",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.openModal("ventas", "mensual")
                            }
                          }
                        },
                        [_c("i", { staticClass: "icon-fa icon-fa-file-text" })]
                      ),
                      _vm._v("  \n            ")
                    ]),
                    _vm._v(" "),
                    _c("td", [_vm._v("Reporte con fechas especificas")]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        "Presenta el reporte de ventas con fechas especificas"
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", [
                      _c(
                        "button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip.top-center",
                              value: "Generar reporte",
                              expression: "'Generar reporte'",
                              modifiers: { "top-center": true }
                            }
                          ],
                          staticClass: "btn btn-primary btn-sm",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.openModal("ventas", "especifico")
                            }
                          }
                        },
                        [_c("i", { staticClass: "icon-fa icon-fa-file-text" })]
                      ),
                      _vm._v("  \n            ")
                    ]),
                    _vm._v(" "),
                    _c("td", [_vm._v("Producto más vendido")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("Presenta los productos más vendidos")])
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", [
                      _c(
                        "button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip.top-center",
                              value: "Generar reporte",
                              expression: "'Generar reporte'",
                              modifiers: { "top-center": true }
                            }
                          ],
                          staticClass: "btn btn-primary btn-sm",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.openModal("ventas", "especifico")
                            }
                          }
                        },
                        [_c("i", { staticClass: "icon-fa icon-fa-file-text" })]
                      ),
                      _vm._v("  \n            ")
                    ]),
                    _vm._v(" "),
                    _c("td", [_vm._v("Cliente que más compra")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("Presenta los clientes que más compran")])
                  ])
                ])
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c(
          "sweet-modal",
          {
            ref: "simple_param_modal",
            attrs: {
              title: _vm.titleModal,
              "hide-close-button": "",
              blocking: ""
            }
          },
          [
            _c("div", { staticClass: "card-body" }, [
              _vm.picker == true
                ? _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c("label", [_vm._v(_vm._s(_vm.typeModal))]),
                      _vm._v(" "),
                      _c("multiselect", {
                        attrs: {
                          options: _vm.arraySimpleParameter,
                          "close-on-select": true,
                          "clear-on-select": false,
                          "show-labels": false,
                          "preserve-search": true,
                          loading: _vm.isLoading,
                          placeholder: "Seleccione",
                          label: "name",
                          "track-by": "id"
                        },
                        on: {
                          input: function($event) {
                            return _vm.$v.simple_parameter.$touch()
                          },
                          "search-change": _vm.filterSelect
                        },
                        model: {
                          value: _vm.simple_parameter,
                          callback: function($$v) {
                            _vm.simple_parameter = $$v
                          },
                          expression: "simple_parameter"
                        }
                      }),
                      _vm._v(" "),
                      _vm.$v.simple_parameter.$error
                        ? _c("div", [
                            !_vm.$v.simple_parameter.required
                              ? _c("span", { staticClass: "error" }, [
                                  _vm._v("El campo es requerido")
                                ])
                              : _vm._e()
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.date == true
                ? _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c("label", [_vm._v("Inicio")]),
                      _vm._v(" "),
                      _c("datepicker", {
                        attrs: {
                          "bootstrap-styling": true,
                          format: _vm.customFormatter,
                          language: _vm.es,
                          placeholder: "Seleccione fecha"
                        },
                        on: {
                          input: function($event) {
                            return _vm.$v.dateinit.$touch()
                          }
                        },
                        model: {
                          value: _vm.dateinit,
                          callback: function($$v) {
                            _vm.dateinit = $$v
                          },
                          expression: "dateinit"
                        }
                      }),
                      _vm._v(" "),
                      _vm.$v.dateinit.$error
                        ? _c("div", [
                            !_vm.$v.dateinit.required
                              ? _c("span", { staticClass: "error" }, [
                                  _vm._v("El campo es requerido")
                                ])
                              : _vm._e()
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c("label", [_vm._v("Final")]),
                      _vm._v(" "),
                      _c("datepicker", {
                        attrs: {
                          "bootstrap-styling": true,
                          format: _vm.customFormatter,
                          language: _vm.es,
                          placeholder: "Seleccione fecha"
                        },
                        on: {
                          input: function($event) {
                            return _vm.$v.dateend.$touch()
                          }
                        },
                        model: {
                          value: _vm.dateend,
                          callback: function($$v) {
                            _vm.dateend = $$v
                          },
                          expression: "dateend"
                        }
                      }),
                      _vm._v(" "),
                      _vm.$v.dateend.$error
                        ? _c("div", [
                            !_vm.$v.dateend.required
                              ? _c("span", { staticClass: "error" }, [
                                  _vm._v("El campo es requerido")
                                ])
                              : _vm._e()
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.datemonth == true
                ? _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c("label", [_vm._v("Seleccione el mes")]),
                      _vm._v(" "),
                      _c("datepicker", {
                        attrs: {
                          "bootstrap-styling": true,
                          "minimum-view": "month",
                          "maximum-view": "month",
                          format: _vm.customFormatter,
                          language: _vm.es,
                          placeholder: "Seleccione fecha"
                        },
                        on: {
                          input: function($event) {
                            return _vm.$v.dateinit.$touch()
                          }
                        },
                        model: {
                          value: _vm.dateinit,
                          callback: function($$v) {
                            _vm.dateinit = $$v
                          },
                          expression: "dateinit"
                        }
                      }),
                      _vm._v(" "),
                      _vm.$v.dateinit.$error
                        ? _c("div", [
                            !_vm.$v.dateinit.required
                              ? _c("span", { staticClass: "error" }, [
                                  _vm._v("El campo es requerido")
                                ])
                              : _vm._e()
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-danger",
                attrs: { slot: "button", type: "button" },
                on: {
                  click: function($event) {
                    return _vm.closeModal()
                  }
                },
                slot: "button"
              },
              [_vm._v("Cancelar")]
            ),
            _vm._v(" "),
            _vm.typeAction == 1
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-primary ladda-button",
                    attrs: {
                      slot: "button",
                      type: "button",
                      "data-style": "expand-right"
                    },
                    on: {
                      click: function($event) {
                        return _vm.saveSimpleReport()
                      }
                    },
                    slot: "button"
                  },
                  [_vm._v("Generar reporte")]
                )
              : _vm._e()
          ]
        ),
        _vm._v(" "),
        _c(
          "sweet-modal",
          {
            ref: "employee_modal",
            attrs: {
              title: _vm.titleModal,
              "hide-close-button": "",
              blocking: ""
            }
          },
          [
            _c("div", { staticClass: "card-body" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("multiselect", {
                    attrs: {
                      options: _vm.arraySimpleParameter,
                      "close-on-select": true,
                      "clear-on-select": false,
                      "show-labels": false,
                      placeholder: "Seleccione un empleado",
                      label: "name",
                      "track-by": "id"
                    },
                    model: {
                      value: _vm.simple_parameter,
                      callback: function($$v) {
                        _vm.simple_parameter = $$v
                      },
                      expression: "simple_parameter"
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-danger",
                attrs: { slot: "button", type: "button" },
                on: {
                  click: function($event) {
                    return _vm.closeModal()
                  }
                },
                slot: "button"
              },
              [_vm._v("Cancelar")]
            ),
            _vm._v(" "),
            _vm.typeAction == 1
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-primary ladda-button",
                    attrs: {
                      slot: "button",
                      type: "button",
                      "data-style": "expand-right"
                    },
                    on: {
                      click: function($event) {
                        return _vm.openModal("personal", "especifico2")
                      }
                    },
                    slot: "button"
                  },
                  [_vm._v("Generar reporte")]
                )
              : _vm._e()
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header" }, [
      _c("h3", { staticClass: "page-title" }, [_vm._v("Reportes")]),
      _vm._v(" "),
      _c("ol", { staticClass: "breadcrumb" }, [
        _c("li", { staticClass: "breadcrumb-item" }, [
          _c("a", { attrs: { href: "#" } }, [_vm._v("Home")])
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "breadcrumb-item active" }, [
          _vm._v("Reportes")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Acciones")]),
        _vm._v(" "),
        _c("th", [_vm._v("Nombre")]),
        _vm._v(" "),
        _c("th", [_vm._v("Descripcion del reporte")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Acciones")]),
        _vm._v(" "),
        _c("th", [_vm._v("Nombre")]),
        _vm._v(" "),
        _c("th", [_vm._v("Descripcion del reporte")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Acciones")]),
        _vm._v(" "),
        _c("th", [_vm._v("Nombre")]),
        _vm._v(" "),
        _c("th", [_vm._v("Descripcion del reporte")])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-01a7969c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01a7969c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/views/admin/settings/Reports.vue
// module id = 743
// module chunks = 0